/* eslint-disable consistent-return */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-nested-ternary */
/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
import { Box, Typography, Skeleton, Chip, useTheme } from '@mui/material';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TimelineIcon from '@mui/icons-material/Timeline';
import CountUp from 'react-countup';

const getVal = (val) => {
  if (Array.isArray(val)) {
    return val.length > 0 ? Number(val[0]) : 0;
  }
  return Number(val) || 0;
};

const percentageVariation = (current, last) => {
  const curVal = getVal(current);
  const lstVal = getVal(last);
  
  if (lstVal > 0) {
    const res = ((curVal - lstVal) / lstVal) * 100;
    return Number(res.toFixed(1));
  }
  if (lstVal === curVal) return 0;
  if (lstVal === 0) return 100;
  return 0;
};

const AnimatedNumber = ({ value, decimals = 0, suffix = '' }) => {
  return (
    <CountUp
      end={value}
      decimals={decimals}
      decimal=","
      separator=" "
      duration={1.2}
      suffix={suffix}
    />
  );
};

const StatsWidget = ({ loading, title, sales, lastSales, amount, icon, description }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const curSales = getVal(sales);
  const variation = percentageVariation(sales, lastSales);

  let chipBg = isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)';
  let chipTextColor = theme.palette.text.secondary;
  let chipIcon = <TimelineIcon fontSize="small" />;

  if (variation > 0) {
    chipBg = isDark ? 'rgba(76, 175, 80, 0.15)' : 'rgba(76, 175, 80, 0.1)';
    chipTextColor = isDark ? '#a5d6a7' : '#2e7d32';
    chipIcon = <TrendingUpIcon fontSize="small" style={{ color: chipTextColor }} />;
  } else if (variation < 0) {
    chipBg = isDark ? 'rgba(244, 67, 54, 0.15)' : 'rgba(244, 67, 54, 0.1)';
    chipTextColor = isDark ? '#ef9a9a' : '#d32f2f';
    chipIcon = <TrendingDownIcon fontSize="small" style={{ color: chipTextColor }} />;
  }

  // Convert amount string to number if needed (e.g. for countup)
  const rawAmount = amount ? Number(String(amount).replace(/\s/g, '').replace('€', '')) || 0 : 0;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {/* Title */}
      <Box>
        {!loading ? (
          <Typography
            color="text.secondary"
            variant="overline"
            sx={{ fontWeight: 700, letterSpacing: '1px', fontSize: '11px', textTransform: 'uppercase' }}
          >
            {title}
          </Typography>
        ) : (
          <Skeleton variant="text" width={100} height={20} animation="wave" />
        )}
      </Box>

      {/* Main Content Row */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          {/* Sales count */}
          {!loading ? (
            <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
              <Typography variant="h4" sx={{ fontWeight: 800, color: 'text.primary' }}>
                <AnimatedNumber value={curSales} />
              </Typography>
              <Typography
                color="text.secondary"
                variant="caption"
                sx={{ fontWeight: 600, textTransform: 'lowercase', opacity: 0.8 }}
              >
                Vente{curSales > 1 ? 's' : ''} comptabilisée{curSales > 1 ? 's' : ''}
              </Typography>
            </Box>
          ) : (
            <Skeleton variant="text" width={150} height={40} animation="wave" />
          )}

          {/* Amount */}
          {!loading ? (
            <Typography variant="h6" sx={{ fontWeight: 700, color: 'primary.main', display: 'flex', alignItems: 'center' }}>
              <AnimatedNumber value={rawAmount} decimals={2} suffix=" €" />
            </Typography>
          ) : (
            <Skeleton variant="text" width={100} height={24} animation="wave" />
          )}
        </Box>

        {/* Trend Indicator */}
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.5 }}>
          {!loading ? (
            <Chip
              icon={chipIcon}
              label={`${variation > 0 ? '+' : ''}${variation}%`}
              size="small"
              sx={{
                backgroundColor: chipBg,
                color: chipTextColor,
                fontWeight: 700,
                fontSize: '12px',
                borderRadius: '8px',
                px: 0.5,
                '& .MuiChip-icon': {
                  marginLeft: '4px',
                  marginRight: '-4px',
                }
              }}
            />
          ) : (
            <Skeleton variant="rectangular" width={60} height={24} animation="wave" sx={{ borderRadius: '8px' }} />
          )}

          {!loading ? (
            <Typography
              color="text.secondary"
              variant="caption"
              sx={{ fontSize: '11px', fontWeight: 500, mt: 0.5 }}
            >
              {description}
            </Typography>
          ) : (
            <Skeleton variant="text" width={80} height={16} animation="wave" />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default StatsWidget;
